import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMenus, getDishesByMenu } from '../services/api';
import './ModernMenu.css';

const ModernMenu = () => {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchMenus();
  }, []);

  useEffect(() => {
    if (selectedMenu) {
      fetchMenuData(selectedMenu);
    }
  }, [selectedMenu]);

  const fetchMenus = async () => {
    try {
      const response = await getMenus();
      setMenus(response.data || []);
      if (response.data && response.data.length > 0) {
        setSelectedMenu(response.data[0]._id);
      }
      setLoading(false);
    } catch (err) {
      console.error('Error fetching menus:', err);
      setError('Failed to load menus');
      setLoading(false);
    }
  };

  const fetchMenuData = async (menuId) => {
    try {
      const response = await getDishesByMenu(menuId);
      setDishes(response.data || []);
      setError('');
    } catch (err) {
      console.error('Error fetching menu data:', err);
      setError('Failed to load menu data');
    }
  };

  const handleDishClick = (dishId) => {
    console.log('Dish clicked with ID:', dishId);
    console.log('Dish ID type:', typeof dishId);
    navigate(`/dish/${dishId}`);
  };

  const handleMenuChange = (menuId) => {
    setSelectedMenu(menuId);
  };

  if (loading) {
    return (
      <div className="modern-menu">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading menus...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-menu">
        <div className="error-container">
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="back-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-menu">
      {/* Header */}
      <header className="menu-header">
        <div className="header-content">
          <h1 className="restaurant-title">حج متولي</h1>
          <p className="restaurant-subtitle">Fine Dining Experience</p>
        </div>
        
        {/* Menu Selector */}
        <div className="menu-selector">
          <div className="menu-tabs">
            {menus.map((menu) => (
              <button
                key={menu._id}
                className={`menu-tab ${selectedMenu === menu._id ? 'active' : ''}`}
                onClick={() => handleMenuChange(menu._id)}
              >
                {menu.name}
              </button>
            ))}
          </div>
        </div>
      </header>

      {/* Menu Grid */}
      <main className="menu-main">
        {!selectedMenu ? (
          <div className="no-categories">
            <h2>Select a Menu</h2>
            <p>Please choose a menu to view dishes</p>
          </div>
        ) : (
          <div className="dishes-grid">
            {dishes.map((dish) => (
              <div 
                key={`dish-${dish._id || dish.id}`} 
                className="dish-card"
                onClick={() => handleDishClick(dish._id || dish.id)}
              >
                <div className="dish-image-container">
                  <img 
                      src={dish.imageUrl || dish.image} 
                      alt={dish.name || 'Dish image'}
                      className="dish-image"
                  />
                  <div className="image-overlay"></div>
                </div>
                
                <div className="dish-content">
                  <h3 className="dish-name">{dish.name || 'Untitled Dish'}</h3>
                  <p className="dish-description">{dish.description || 'No description available'}</p>
                  <div className="dish-footer">
                    <span className="dish-price">${(dish.price || 0).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default ModernMenu;
